import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';
import {
  siteSettings, homeContent, faqs, pageContent, galleryImages,
  teamMembers, manufacturers, jobOpenings, serviceAreas, serviceOptions, careersHtml, rebateBanner
} from '../data/mock';

// Fallback mirrors backend content shape so the site renders even if API is down.
export const fallbackContent = {
  siteSettings, homeContent, faqs, pageContent, galleryImages,
  teamMembers, manufacturers, jobOpenings, serviceAreas, serviceOptions, careersHtml, rebateBanner
};

const ContentContext = createContext(fallbackContent);
export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(fallbackContent);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get('/content')
      .then((r) => { if (mounted && r.data) setContent({ ...fallbackContent, ...r.data }); })
      .catch(() => {})
      .finally(() => { if (mounted) setLoaded(true); });
    return () => { mounted = false; };
  }, []);

  return <ContentContext.Provider value={{ ...content, _loaded: loaded }}>{children}</ContentContext.Provider>;
};
